import { Season, SeasonSegment } from "model/Tournament/Segment/Season/Season";
import {
  FsSeason,
  FsSeasonSegment,
} from "db/model/tournament/Segment/Season/FsSeason";
import { mapRoundsSegmentGroupBase } from "../FsRoundsSegmentGroup";
import { nonUndefined } from "Utility";
import { mapTournamentSegmentBase } from "../FsTournamentSegment";
import {
  mapAltSeasonPointsRules,
  mapSeasonPointsRules,
} from "./FsSeasonPointRules";

export const mapSeasonSegment = (
  fsModel: FsSeasonSegment
): SeasonSegment | undefined => {
  const base = mapTournamentSegmentBase(fsModel, fsModel.type, mapSeasons);
  if (!base) {
    return undefined;
  }

  return {
    ...base,
    altPoints: !!fsModel.altPoints
      ? mapAltSeasonPointsRules(fsModel.altPoints)
      : undefined,
    points: !!fsModel.points ? mapSeasonPointsRules(fsModel.points) : undefined,
    pointsOverrides: fsModel.pointsOverrides,
  };
};

const mapSeasons = (fsModels: FsSeason[]): Season[] => {
  return nonUndefined(fsModels.map(mapSeason));
};

const mapSeason = (fsModel: FsSeason): Season | undefined => {
  return {
    ...mapRoundsSegmentGroupBase(fsModel),
  };
};
